import React, { useState, useEffect } from "react";
import { ReactComponent as Featherclock } from "assets/images/featherclock.svg";
import discountedText from "assets/images/discountedText.png";
import discountedLogo from "assets/images/discountedLogo.png";
import "./ProductCarousel.scss";
import Countdown from "react-countdown";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper";
import { BsFillStarFill } from "react-icons/bs";
import { baseURL } from "constants/constants";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

const ProductCarousel = ({ data }) => {
  const products = data;
  const [time, setTime] = useState();
  const [countdown, setCountdown] = useState(true);
  useEffect(() => {
    setTime(new Date().getTime());
  }, []);
  let bId = useParams();
  return (
    <div className="container-fluid carousel-container p-0">
      {/* <div className="carousel d-flex justify-content-around align-items-center mw-100 flex-column flex-sm-row "> */}
      {/* <div className="d-flex flex-row flex-sm-column justify-content-center align-items-center discounted-image">
          <img src={discountedText} alt="discountedText" />
          <img src={discountedLogo} alt="discountedLogo" />
        </div> */}
      <div className="slides-wrapper">
        <Swiper
          breakpoints={{
            1200: {
              slidesPerView: 5,
              spaceBetween: 20
            },
            900: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            700: {
              slidesPerView: 3.5,
              spaceBetween: 20
            },
            600: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            450: {
              slidesPerView: 2.5,
              spaceBetween: 10
            },

            320: {
              slidesPerView: 2,
              spaceBetween: 10
            }
          }}
          // breakpoints={{
          //   768: {
          //     slidesPerView: 1
          //   },
          //   1000: {
          //     slidesPerView: 2
          //   },
          //   1300: {
          //     slidesPerView: 3
          //   },
          //   1400: {
          //     slidesPerView: 4
          //   }
          // }}
          slidesPerView={1}
          // loop={true}
          spaceBetween={15}
          navigation={true}
          modules={[Navigation]}
        >
          <SwiperSlide>
            <div className="discounted-image position-relative">
              <img
                src={discountedText}
                style={{
                  // position: "absolute",
                  width: "160px",
                  height: "120px",
                  marginTop: "30px",
                  marginRight: "40px"
                }}
                alt="discountedText"
              />
              <img
                src={discountedLogo}
                style={{
                  // position: "absolute",
                  width: "220px",
                  height: "220px",
                  bottom: "0",
                  // marginTop: "px",
                  right: "-50px"
                }}
                alt="discountedLogo"
              />
            </div>
          </SwiperSlide>
          {products?.map(item => (
            <SwiperSlide key={item.info.id}>
              <NavLink to={`/product/${item.info.id}/${bId.businessId}/1`}>
                <div id="carousel-card" className="card ">
                  <div className="img-wrapper d-flex justify-content-center align-items-center">
                    <img
                      src={baseURL + item.info.cover[0].url}
                      alt={item.info.title}
                    />
                  </div>
                  <div className="card-body">
                    <div
                      className="text-center mx-2"
                      style={{ height: "40px" }}
                    >
                      <span
                        className=" title-style"
                        style={{ fontSize: "14px" }}
                      >
                        {item.info.title}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between align-items-start my-2 gap-2">
                      {item.info.main_discount != "0" ? (
                        <span className="price-tag text-decoration-line-through text-danger">
                          {addCommas(item.info.main_price)}
                        </span>
                      ) : (
                        <span></span>
                      )}
                      <span className="price-tag text-success">
                        {addCommas(
                          item.info.main_price - item.info.main_discount
                        )}
                        تومان
                      </span>
                    </div>
                    {/* // <div className="text-end mx-2">
                      //   <span className="price-tag ">
                      //     {addCommas(item.info.main_price)}
                      //   </span>
                      // </div> */}
                    {/* <div className="d-flex justify-content-around">
                      <h6>{item.info.}</h6>
                      <img src={`http://marketgroup.tatdemo.ir/${item.info.}`} style={{width:'50px',height:'50px'}} />
                    </div> */}
                    <div className="d-flex justify-content-center align-items-center mt-3">
                      {item.info.main_discount_endtime && countdown ? (
                        <>
                          <Countdown
                            date={
                              parseInt(item.info.main_discount_endtime) * 1000
                              // 1661174985000
                            }
                            // daysInHours={true}
                            onComplete={() => setCountdown(false)}
                          />

                          <i className="mx-1">
                            {<Featherclock className="countdown-clock" />}
                          </i>
                        </>
                      ) : (
                        <small className="mt-3">
                          زمان تخفیف به پایان رسید!
                        </small>
                      )}
                    </div>
                  </div>
                </div>{" "}
              </NavLink>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
    // </div>
  );
};

export default ProductCarousel;
